import CatalogVendorSuggestions from './CatalogVendorSuggestions';
// src/components/PhoneModal.js
import React, { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

const PhoneModal = ({ onCancel, onConfirm, stakeholderType, token }) => {
  const [raw, setRaw] = useState('');
  const [vendorSearch, setVendorSearch] = useState('');
  const [vendorQuery, setVendorQuery] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  // keep only digits
  const digits = useMemo(() => (raw || '').replace(/\D+/g, ''), [raw]);
  const isValid = digits.length === 10;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid || busy) return;
    setBusy(true); setError('');
    try { await onConfirm?.(digits); }
    catch (err) { setError(err.message || 'Unable to prepare payment. Please retry.'); }
    finally { setBusy(false); }
  };

  return createPortal(
    <div
      className="responsive-dialog fixed inset-0 z-[10000] bg-black/50 backdrop-blur-[1px] flex items-start justify-center pt-6 px-3"
      role="dialog"
      aria-modal="true"
      aria-labelledby="phone-modal-title"
      onClick={(e) => {
        if (!busy && e.target === e.currentTarget) onCancel?.();
      }}
    >
      <form
        className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-4"
        onSubmit={handleSubmit}
      >
        <h2 id="phone-modal-title" className="text-lg font-bold mb-2 text-center">
          {stakeholderType === 'vendor' ? 'Vendor Mobile Number' : stakeholderType === 'outlet' ? 'Outlet Contact Mobile Number' : '📱 Customer Mobile Number'}
        </h2>

        <p className="text-center text-sm text-slate-600 mb-3">
          Please enter a 10-digit mobile number
        </p>

        {stakeholderType === 'vendor' && <label className="mb-2 block text-sm">Find catalog vendor<input disabled={busy} value={vendorSearch} onChange={e => { setVendorSearch(e.target.value); setVendorQuery(e.target.value); setRaw(''); }} placeholder="Vendor name" className="w-full rounded border p-2" /></label>}
        <input
          // numeric keypad on mobile
          disabled={busy}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          autoFocus
          value={raw}
          onChange={(e) => { setRaw(e.target.value); setVendorQuery(e.target.value); setVendorSearch(''); }}
          className="w-full border rounded p-2 text-center mb-2"
          placeholder="e.g. 9876543210"
          maxLength={14}
        />

        {stakeholderType === 'vendor' && <CatalogVendorSuggestions query={vendorQuery} token={token} disabled={busy} onSelect={vendor => { setRaw(vendor.phoneNo); setVendorSearch(vendor.name); setVendorQuery(''); }} />}
        <div className="h-5 mb-3 text-center text-sm">
          {raw ? (
            isValid ? (
              <span className="text-green-700 font-medium">Looks good</span>
            ) : (
              <span className="text-red-600">Enter exactly 10 digits</span>
            )
          ) : null}
        </div>

        {error && <p role="alert" className="text-red-600 mb-2">{error}</p>}
        <div className="flex gap-2">
          <button
            type="submit"
            disabled={!isValid || busy}
            className="flex-1 bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:opacity-50"
          >
            {busy ? 'Preparing payment…' : 'Continue'}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="flex-1 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
};

export default PhoneModal;
